function SuccessBanner(message) {
	this._element = $("<div class='notice-box-outer' data-notice-box='true'><div data-success-banner='true'><div class='b-alert b-alert-success'></div></div>");
	this._element.find('.b-alert').html("<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>&times;</button><span></span>");
	this._element.find('span').text(message);

	var self = this;
	this._element.on('click', '[data-dismiss]', function() { self.dismiss(); });
}

SuccessBanner.prototype = {
	show: function(noAutoHide) {
		this._element.appendTo(document.body);
		var HH = $(this._element).find('[data-success-banner]');
		HH.css({ marginTop: (0 - (HH.height() / 2)) + 'px' });
		var self = this;
		$('body').on('click.success-banner', function() { self._autoHide(); }); // If you start doing something else, it goes away.
		if (!noAutoHide) {
			this._hideTimer = setTimeout(function() { self._autoHide(); }, 6000);
		}
	},
	
	dismiss: function() {
		$('body').off('click.success-banner');
		clearTimeout(this._hideTimer);
		this._element.remove();
	},
	
	_autoHide: function() {
		$('body').off('click.success-banner');
		this._element.addClass('animate-out');
		clearTimeout(this._hideTimer);
		var self = this;
		this._hideTimer = setTimeout(function() { self.dismiss(); }, 350);
	}
};

